module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_0.f34f0fb9.png";